import React, {useState, useRef, useEffect} from 'react';
import ActionItemListSectionAssigned from "./ActionItemListSectionAssigned.mjs";
import ActionItemListItemMessage from "./ActionItemListItemMessage.mjs";
import TeamListAssignedDefaultMessage from "./TeamListAssignedDefaultMessage.mjs";
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = true;

export default function TeamAssignedActionItemList() 
{
    const { team, action_item, setActionItem, num_display_columns, setMainColumnDisplayType, 
            action_item_list_local_refresh, setActionItemListLocalRefresh, action_item_team_list_refresh, setActionItemTeamListRefresh } = useCTAL();

    const [items_ready, setItemsReady] = useState(false);
    const [users_list, setUsersList] = useState([]);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const fetchRef = useRef("");

    useEffect(() =>
    {
        if (!team) return;
      
        if (fetchRef.id == team.TeamID) return;
        
        fetchRef.id = team.TeamID;
        fetch_assigned_actions();
    }, [team]);
    
    useEffect(() =>
    {
        if (loading) return; //Don't display Assigned Action list(s) until they are ready
        
        setItemsReady(true); 

        if (users_list.length > 0) {
            let first_user_actions = items.filter( item => { return ((item.Type === "Action-Item") && (item.AssignedUserID == users_list[0].UserID)); } );
            if (first_user_actions.length > 0) setActionItem(first_user_actions[0]);
        }
    }, [items]);
       
    useEffect(() =>
    {
        if ((!items) || (items.length <= 0)) return;
        
        if (action_item_team_list_refresh) {
            setActionItemTeamListRefresh(false);
            fetch_assigned_actions(); //Assigned User was changed, need to re-fetch Assigned Actions List    
        }
    }, [action_item_team_list_refresh]);
    
    useEffect(() =>
    {
        if (action_item_list_local_refresh) {
            refresh_current_action_item_in_list();
            populate_assigned_actions( [...items] ); //minor Action change, just manually refresh local Assigned Action List
        }
    }, [action_item_list_local_refresh]);

    const refresh_current_action_item_in_list = () => { 
        setActionItemListLocalRefresh(false);

        if ((!action_item) || (!items)) return;

        if (DEBUG) console.log(`TeamAssignedActionItemList*** - RECEIVED action_item_list_local_refresh for Action-Item ${action_item.Name}`)
              
        //Search and Replace updated Action Item
        for (var i=0; i < items.length; i++) {
            if (items[i].Type != 'Action-Item') continue;
            if (items[i].Name == action_item.Name) items[i] = action_item;
        }
    }

    const fetch_assigned_actions = () => {
        var type = "get_assigned_team_action_items_all";
        var team_id = team.TeamID;

        var search_body = JSON.stringify({type, team_id});

        setLoading(true);
        setItemsReady(false);

        console.log(`TeamAssignedActionItemList - fetching Team Assigned Action List from ctal-get for: ${team_id}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-get`, { method: "POST", body: search_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: search_body })
            .then(response => response.json())
            .then(populate_assigned_actions)
            .then(() => setLoading(false))
            .catch(setError);
    }

    const populate_assigned_actions = (rcv_items) => {
        setItems(rcv_items);

        var users = rcv_items.filter( item => { return (item.Type === "User"); } );
        
        users.sort( (a, b) => {
            if (a.UserID < b.UserID) return -1;
            if (a.UserID > b.UserID) return  1;
            return 0; 
        });

        setUsersList(users);
    }   

    const display_action_item = (action_item) => { 
        if (DEBUG) console.log(`TeamAssignedActionItemList - setting action item detail display to: ${action_item.Name}`);
        setActionItem(action_item);
        if (num_display_columns == 1)
            setMainColumnDisplayType("Action-Item");    
    }

    if (error) return <ActionItemListItemMessage message={JSON.stringify(error, null, 2)} /> 
    
    if (!loading && items_ready && (items.length == 0)) { setActionItem(undefined); return <> <TeamListAssignedDefaultMessage /> </>; }
    if ((!items) || (!users_list)) { setActionItem(undefined); return (<></>); }
    if (users_list.length == 0) { setActionItem(undefined); return (<></>); }

    return ( 
        <> 
            <h6 className="mt-2 text-center">- Assigned Team Actions -</h6>
            { users_list?.map( (user, i) => (  
                <ActionItemListSectionAssigned heading={user.UserFullName} 
                                               action_item_list_section={items.filter( item => { return ((item.Type === "Action-Item") && (item.AssignedUserID == user.UserID)); } )} 
                                               displayActionItem={display_action_item} 
                                               key={i} /> )) }
        </> 
    );
}